import {Helmet} from "react-helmet";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary, RaikoCreatorInfo, RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {css} from "@emotion/css";
import OccasionalBannerDetailsThumbnail from "./OccasionalBannerDetailsThumbnail";
import OccasionalBannerDetailsBasicInfo from "./OccasionalBannerDetailsBasicInfo";
import OccasionalBannerDetailsPublicationStatus from "./OccasionalBannerDetailsPublicationStatus";
import {useLocation, useNavigate, useParams} from "react-router-dom";

export default function OccasionalBannerDetails() {

    const {state} = useLocation()
    const {id: bannerId} = useParams()

    const [selectedValueTabMenu, setSelectedValueTabMenu] = useState(occasionalBannerTabType.BasicInformation.id)
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.OccasionalBanner.name);
    const [createdBy, setCreatedBy] = useState("");
    const [createDate, setCreateDate] = useState("");

    function handleChangeTabMenu(event, newValue) {
        setSelectedValueTabMenu(newValue)
    }

    const navigate = useNavigate()
    return (
        <>
            <Helmet>
                <title>{RouteHelper.OccasionalBannerDetail.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Android.name, ""),
                            raikoBreadCrumbItemGenerator(RouteHelper.OccasionalBanner.name, RouteHelper.OccasionalBanner.globalUrl),
                            raikoBreadCrumbItemGenerator(pageTitle, ""),
                        ]}/>
                        <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                            navigate(-1)
                        }}/>
                    </RaikoFlexFirstChildGrowOne>
                    <TabContext value={selectedValueTabMenu}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                                <Tab iconPosition="start"
                                     label={occasionalBannerTabType.BasicInformation.title}
                                     value={occasionalBannerTabType.BasicInformation.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={occasionalBannerTabType.BasicInformation.id}>
                            <RaikoGridOneColumn>
                                <OccasionalBannerDetailsBasicInfo bannerId={bannerId} setCreatedBy={setCreatedBy}
                                                                  setCreateDate={setCreateDate}/>
                                <OccasionalBannerDetailsThumbnail bannerId={bannerId}/>
                                <OccasionalBannerDetailsPublicationStatus bannerId={bannerId}/>
                                <RaikoCreatorInfo createdBy={createdBy} createdAt={createDate}/>
                            </RaikoGridOneColumn>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const occasionalBannerTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },

}